import { ComponentType } from "react";

import { bridge } from "@multiweb/reactCore/bridge";
import { LiteListFrameGeneralAttributeProps } from "../../../../LiteListFrameGeneralAttribute";
import { LiteListFrameIconAttributeComponent } from "../../../../LiteListFrameIconAttributeComponent";
import { LLFAbstractRenderer } from "./LLFAbstractRenderer";

const { stringToBoolean } = bridge;

export class LLFIconAttributeRenderer extends LLFAbstractRenderer {
    public canRender(element: HTMLElement): boolean {
        return stringToBoolean(element.getAttribute("data-isicon"), false);
    }

    public override get component(): ComponentType<LiteListFrameGeneralAttributeProps> {
        return LiteListFrameIconAttributeComponent;
    }
}
